import { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import useSWR from 'swr';
import analytics from '~/analytics';
import Container from '~/containers/Chat';
import statistics from '~/containers/Chat/statistics';
import { ACCESS_TOKEN_KEY } from '~/utils/constants';

export default function NewChat({ ...pageProps }: any) {
  const isViewStatSent = useRef(false);
  const [cookies] = useCookies([ACCESS_TOKEN_KEY]);
  const [readyToView, setReadyToView] = useState(false);
  const { data: newChatPage, mutate } = useSWR('global://new-chat');

  useEffect(() => {
    const handleServiceLoad = () => {
      if (!cookies[ACCESS_TOKEN_KEY]) return;
      setReadyToView(() => true);
    };

    if (window.self === window.top) {
      handleServiceLoad();
    }
  }, [cookies]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      const { buzzni_shopping_gpt_new_chat_open: isIframeOpen } =
        event.data ?? {}; // 레거시: 쇼핑어시스턴트 챗봇SDK에서 전달하는 챗봇 오픈 여부
      if (isIframeOpen === undefined) return;

      if (isIframeOpen) {
        setReadyToView(() => true);
        mutate({ iframeOpen: true }, { revalidate: false });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    if ((readyToView || newChatPage?.iframeOpen) && !isViewStatSent.current) {
      isViewStatSent.current = true;
      analytics.trigger(statistics('__view__', 'view', { conver_id: 'new' }));
    }
  }, [readyToView, newChatPage]);

  return <Container {...pageProps} />;
}
